// import requests from "./httpService";

// import getEmployeeId from "utils/commonAdmin";


// const DriverServices = {
//   getDriverList: async (type) => {
//     const id_employee =await getEmployeeId(); 
//     return requests.get(`/driver/employee/getAllList/${type}/${id_employee}`);
//   },

//   getAllDriverRequestQueue: async () => {
//     const id_employee =await getEmployeeId(); 
//     return requests.get(`/driver/employee/requestQueue/${id_employee}`);
//   },

//   addDriver: async (body) => {
//     const id_employee =await getEmployeeId(); 
//     return requests.post(`/driver/add/${id_employee}`, body);
//   },

//   getDriverById: async (id) => {
//     return requests.get(`/driver/${id}`);
//   },

//   updateDriver: async (id, body) => {
//     const id_employee =await getEmployeeId(); 
//     return requests.put(`/driver/update/${id}/${id_employee}`, body);
//   },

//   updateStatus: async (id, body) => {
//     const id_employee =await getEmployeeId(); 
//     return requests.patch(`/driver/status/${id}/${id_employee}`, body);
//   },

//   updateRequestQueueStatus: async (id, type, body) => {
//     return requests.put(
//       `/driver/employee/statusupdate/${id}?type=${type}`,
//       body
//     );
//   },

//   deleteDriver: async (id) => {
//     const id_employee =await getEmployeeId(); 
//     return requests.put(`/driver/delete/${id}/${id_employee}`);
//   },
//   updateDriverStatus: async (id, body) => {
//     const id_employee =await getEmployeeId(); 
//     return requests.put(`/driver/status/${id}/${id_employee}`, body);
//   },
//   updateDriverBlockStatus: async (id, body) => {
//     const id_employee =await getEmployeeId(); 
//     return requests.put(`/driver/blockStatus/${id}/${id_employee}`, body);
//   },
// };

// export default DriverServices;





import requests from "./httpService";

import getEmployeeId from "utils/commonAdmin";


const DriverServices = {

  //Add Driver
  addDriver: async (body) => {
    return requests.post(`/driver/add`, body);
  },

  //Update Driver
  updateDriver: async (id, body) => {
    return requests.put(`/driver/update/${id}`, body);
  },

  //Verify - Approval / Reject
  updateStatus: async (id, body) => {
    return requests.patch(`driver/verify/${id}`, body);
  },

  //toggle driver status
  updateDriverBlockStatus: async (id, body) => {
    return requests.patch(`driver/block-status/${id}`, body);
  },

  //Driver get listing
  getDriverList: async (type) => {
    return requests.get(`driver/getAllList/${type}`);
  },

  //Deleting Driver
  deleteDriver: async (id) => {
    return requests.patch(`driver/delete-status/${id}`);
  },

  getAllDriverRequestQueue: async () => {
    const id_employee = await getEmployeeId();
    return requests.get(`/driver/employee/requestQueue/${id_employee}`);
  },

  getDriverById: async (id) => {
    return requests.get(`/driver/${id}`);
  },

  // updateStatus: async (id, body) => {
  //   const id_employee = await getEmployeeId();
  //   return requests.patch(`/driver/status/${id}/${id_employee}`, body);
  // },


  // deleteDriver: async (id) => {
  //   const id_employee = await getEmployeeId();
  //   return requests.put(`/driver/delete/${id}/${id_employee}`);
  // },
  updateDriverStatus: async (id, body) => {
    const id_employee = await getEmployeeId();
    return requests.put(`/driver/status/${id}/${id_employee}`, body);
  },
  // updateDriverBlockStatus: async (id, body) => {
  //   const id_employee = await getEmployeeId();
  //   return requests.put(`/driver/blockStatus/${id}/${id_employee}`, body);
  // },
};

export default DriverServices;
